module.exports = __webpack_public_path__ + "img/noti5.2df675f2.jpeg";